import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Container, Card, Button, InputGroup } from "react-bootstrap";
import "../../../CommonCSS/SocietyCSS.css";
import Compensatory_LeaveApp from "./Compensatory_LeaveApp";

const Compensatory_Leave = () => {

  const initialState = {
    la_id: '',
    emp_id: '',
    leave_appl_date: '',
    leave_id: '',
    from_leave_date: '',
    from_hd: '',
    to_leave_date: '',
    to_hd: '',
    leave_reason: '',
    prefix: '',
    suffix: '',
    supervisor_status: '',
    supervisor_appr_id: '',
    supervisor_remarks: '',
    hm_status: '',
    hm_appr_id: '',
    hm_appr_remarks: '',
    director_status: '',
    director_appr_id: '',
    director_remarks: '',
    visiting_dept: '',
    visiting_person: '',
    visit_cont_no: '',
    supervisor_appr_date: '',
    hm_appr_date: '',
    md_appr_date: '',
    from_appr_date: '',
    to_appr_date: '',
    from_appr_hd: '',
    to_appr_hd: '',
    to_lwp_date: '',
    visit_from_time: '',
    visit_to_time: '',
    from_tot_leaves: '',
    to_tot_leaves: '',
  };

  const [formData, setFormData] = useState(initialState);
  const [isEditable, setIsEditable] = useState(false);
  const [mode, setMode] = useState("view");
  // modes: "view" | "new" | "edit"


  // ================= FETCH DATA =================
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/get_leave_application`);
        if (response.data.length > 0) {
          setFormData(response.data[0]);
          setIsEditable(false);
        }
      } catch (error) {
        console.error("Fetch Error:", error);
      }
    };

    fetchData();
  }, []);

  // ================= HANDLE CHANGE =================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ================= NEW =================
  const handleNew = () => {
    setFormData(initialState);
    setIsEditable(true);

  };

  // ================= EDIT =================
  const handleEdit = () => {
    setIsEditable(true);
    setMode("edit");
  };


  // ================= CLEAR =================
  const handleClear = () => {
    if (!window.confirm("Clear form?")) return;
    setFormData(initialState);
    setIsEditable(false);
    setMode("view");
  };



  // ================= SAVE =================
  const handleSave = async () => {
    if (!formData.employee_name) {
      alert("Please enter Employee Name");
      return;
    }

    try {
      const response = await axios.post(
        `${BASE_URL}/api/save_leave_application`,
        formData
      );

      if (response.data.success) {
        alert("Record Saved Successfully");
        setIsEditable(false);
      }
    } catch (error) {
      alert("Save Failed");
      console.error(error);
    }
  };

  // ================= DELETE =================
  const handleDelete = async () => {
    if (!formData.la_id) {
      alert("No record selected");
      return;
    }

    const confirmDelete = window.confirm("Are you sure you want to delete?");
    if (!confirmDelete) return;

    try {
      await axios.delete(
        `${BASE_URL}/api/delete_leave_application/${formData.la_id}`
      );
      alert("Record Deleted");
      handleNew();
    } catch (error) {
      alert("Delete Failed");
    }
  };

  return (
    <Container fluid className="p-3">
      <Card className="mb-4">
        <Card.Header className="fw-bold" style={{ backgroundColor: "#c3cdf0", color: "black" }}>
          Compensatory Leave Application
        </Card.Header>
        <Card.Body>
          {/* <hr /> */}
          {/* ================= ROW 1 ================= */}
          <Row className="mb-3">
            <Col md={6} className="mb-2">
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>
                  Employee Name
                </InputGroup.Text>
                <input
                  type="text"
                  className="form-control"
                  name="employee_name"
                  value={formData.employee_name}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>

            <Col md={6} className="mb-2">
              <InputGroup>
                <InputGroup.Text style={{ width: "145px" }}>
                  Application Date
                </InputGroup.Text>
                <input
                  type="date"
                  className="form-control"
                  name="leave_appl_date"
                  value={formData.leave_appl_date}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
          </Row>

          {/* ================= ROW 3 ================= */}

          <Row className="mb-3">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>
                  Leave Name
                </InputGroup.Text>
                <select
                  className="form-select"
                  name="leave_id"
                  value={formData.leave_id}
                  onChange={handleChange}
                  disabled={!isEditable}
                >
                  <option value="">-- Select Leave --</option>

                </select>
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>
                  Leave Reason
                </InputGroup.Text>
                <input
                  type="text"
                  className="form-control"
                  name="leave_reason"
                  value={formData.leave_reason}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
          </Row>


          {/* ================= ROW 3 ================= */}
          <Row className="mb-3">
            <Col md={2}>
              <label className="form-label"> Leave From Date</label>
              <input
                type="date"
                className="form-control"
                name="from_leave_date"
                value={formData.from_leave_date}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </Col>

            <Col md={2} style={{ marginTop: "32px" }}>
              <InputGroup>
                <InputGroup.Text style={{ width: "120px" }}
                >Prefix</InputGroup.Text>
                <InputGroup.Text>
                  <input
                    type="checkbox"
                    checked={formData.prefix === "YES"}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "prefix",
                          value: e.target.checked ? "YES" : "NO"
                        }
                      })
                    }
                    disabled={!isEditable}
                  />
                </InputGroup.Text>
              </InputGroup>
            </Col>
            <Col md={2} style={{ marginTop: "32px" }}>
              <InputGroup>
                <InputGroup.Text style={{ width: "145px" }}>
                  Half Day
                </InputGroup.Text>
                <InputGroup.Text>
                  <input
                    type="checkbox"
                    className="form-check-input mt-0"
                    name="from_hd"
                    checked={formData.from_hd === "Y"}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "from_hd",
                          value: e.target.checked ? "Y" : "N"
                        }
                      })
                    }
                    disabled={!isEditable}
                  />
                </InputGroup.Text>
              </InputGroup>
            </Col>

            <Col md={2}>
              <label className="form-label">Leave To Date</label>
              <input
                type="date"
                className="form-control"
                name="to_leave_date"
                value={formData.to_leave_date}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </Col>

            <Col md={2} style={{ marginTop: "32px" }}>
              <InputGroup>
                <InputGroup.Text style={{ width: "120px" }}>Suffix</InputGroup.Text>
                <InputGroup.Text>
                  <input
                    type="checkbox"
                    checked={formData.suffix === "YES"}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "suffix",
                          value: e.target.checked ? "YES" : "NO"
                        }
                      })
                    }
                    disabled={!isEditable}
                  />
                </InputGroup.Text>
              </InputGroup>
            </Col>

            <Col md={2} style={{ marginTop: "32px" }}>
              <InputGroup>
                <InputGroup.Text style={{ width: "145px" }}>
                  Half Day
                </InputGroup.Text>
                <InputGroup.Text>
                  <input
                    type="checkbox"
                    className="form-check-input mt-0"
                    name="to_hd"
                    checked={formData.to_hd === "Y"}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "to_hd",
                          value: e.target.checked ? "Y" : "N"
                        }
                      })
                    }
                    disabled={!isEditable}
                  />
                </InputGroup.Text>
              </InputGroup>
            </Col>
          </Row>
        </Card.Body>

        {/* ================= BUTTONS ================= */}
        <Card.Body>
        <Row className="mb-2 justify-content-end">
          <Col md="auto">
            <Button variant="primary"
              className="me-2"
              style={{ width: "135px" }}
              disabled={isEditable}
              onClick={handleNew}>
              New
            </Button>

            <Button
              variant="warning"
              className="me-2"
              style={{ width: "135px" }}
              onClick={handleEdit}
              disabled={!formData.la_id}
            >
              Edit
            </Button>

            <Button
              variant="danger"
              className="me-2"
              style={{ width: "135px" }}
              onClick={handleDelete}
              disabled={!formData.la_id}
            >
              Delete
            </Button>

            <Button
              variant="secondary"
              className="me-2"
              style={{ width: "135px" }}
              onClick={handleClear}
            >
              Clear
            </Button>

            <Button
              variant="success"
              onClick={handleSave}
              style={{ width: "135px" }}
              disabled={!isEditable}
            >
              Save
            </Button>
          </Col>
        </Row>
        </Card.Body>
      </Card>


      {/* ***********NEW***************** */}

      <Card className="mt-4">
        <Card.Header className="fw-bold" style={{ backgroundColor: "#c3cdf0", color: "black" }}>
          Visiting Details
        </Card.Header>
        <Card.Body>
          {/* <hr /> */}


          <Row className="mb-3">
            <Col md={6} className="mb-2">
              <InputGroup>
                <InputGroup.Text style={{ width: "170px" }}>
                   Department Name
                </InputGroup.Text>
                <input
                  type="text"
                  className="form-control"
                  name="visiting_dept"
                  value={formData.visiting_dept}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
            <Col md={6} className="mb-2">
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>
                   Person Name
                </InputGroup.Text>
                <input
                  type="text"
                  className="form-control"
                  name="visiting_person"
                  value={formData.visiting_person}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6} className="mb-2">
              <InputGroup>
                <InputGroup.Text style={{ width: "170px" }}>
                  Mobile No.
                </InputGroup.Text>
                <input
                  type="number"
                  className="form-control"
                  name="visit_cont_no"
                  value={formData.visit_cont_no}
                  onChange={handleChange}
                  disabled={!isEditable}
                />
              </InputGroup>
            </Col>
            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>From Time</InputGroup.Text>
                <input
                  style={{ textAlign: "right" }}
                  type="time"
                  className="form-control"
                  name="visit_from_time"
                  value={formData.visit_from_time}
                  disabled={!isEditable}
                // onChange={handleHeaderChange}
                /> 
                </InputGroup>
                </Col>
                <Col md={3}>
                 <InputGroup>
                <InputGroup.Text style={{ width: "140px" }}>	To Time</InputGroup.Text>
                <input
                  style={{ textAlign: "right" }}
                  type="time"
                  className="form-control"
                  name="visit_to_time"
                  value={formData.visit_to_time}
                  disabled={!isEditable}
                // onChange={handleHeaderChange}
                />
              </InputGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Compensatory_Leave;
